module.exports = __webpack_public_path__ + "img/logo-club-de-golf-pachuca.ae68e993.webp";